// WHEN THE CARD IS CHARGED, SAID THE WAY THE SERVER DOES IT.
//
// CHARGE_ON_COMPLETION (docs/DECISIONS.md, 2026-10-06) moves the charge from
// the moment an operator takes the job to the moment the wash is marked done.
// The words have to move with it, in the same flip, so the server publishes
// the switch in the `gwmc:payment` meta tag (app/views/layouts/gwmc.html.haml)
// and every sentence about paying reads it here. Never a build-time constant:
// one env change and a deploy changes the behaviour and the copy together.
//
// Off is today's copy, word for word (DESIGN.md §8.4). On is Fable's ruling
// copy, the same words SeoHelper::PAYMENT_ON_COMPLETION puts in the FAQPage
// block. No meta tag (a page rendered by another layout) reads as off,
// because off is what production does until Robin flips it.

const readMode = () => {
  if (typeof document === 'undefined') return null
  const tag = document.querySelector('meta[name="gwmc:payment"]')
  return tag ? tag.getAttribute('content') : null
}

export const chargesOnCompletion = () => readMode() === 'on_completion'

// THERE IS NO foldPayClause() ANY MORE (2 Nov 2026). The fold's subhead was
// "A vetted, insured operator, anywhere in London." plus a pay clause whose
// wording read this switch, because Fable's 31 Oct ruling wrote it as "pay
// once your car is clean" and that is only true while CHARGE_ON_COMPLETION is
// on. The positioning change replaced the whole sentence with the come-to-you
// promise, the fixed price and the speed, so the first screen now makes NO
// claim about when the card is charged. That is true on either setting and
// needs no twin. Every sentence below still reads the switch, and those are
// the ones a payer actually sees.
//
// The lead sentence, for the places that show one line.
export const payLead = () =>
  chargesOnCompletion() ? 'You pay once your car is clean.' : 'Your card is charged shortly after your booking is made.'

// The one line under the pay button on Book & pay, on every path (the legacy
// card button, the embedded card form, the Stripe-page fallback). Ruled 9 Oct
// 2026 (Robin: "keep the your card is charged stuff after the green button").
export const bookPayChargeLine = () =>
  chargesOnCompletion()
    ? 'You pay once your car is clean. Your card stays with Stripe, never with us.'
    : 'Charged shortly after you book. Your card stays with Stripe, never with us.'

// The line above the pay buttons on the embedded Book & pay screen, with the
// charge line below them: the card reassurance sits either side of the
// buttons, once each, where every payer sees it. Robin, 12 Oct 2026: "we
// still need to inc something about card security but only either side of
// the booking links.." Stripe named, never "PCI" (DESIGN.md §8.5).
export const securePaymentLine = () => 'Secure payment by Stripe'

// The sentence that follows it.
export const payDetail = () =>
  chargesOnCompletion()
    ? 'We keep your card on file with Stripe and take payment when the wash is done, so booking again is one tap.'
    : 'We keep it on file to make repeat bookings easy. Stripe holds it, so we never see or store the details.'
